import { ShoppingContext, StoreContext } from '../data/model';
import RouteDefinitions from '../RouteDefinitions';
import { BaseShareConfiguratorUrlProvider } from './BaseShareConfiguratorUrlProvider';
import { StoreUrlBuilder } from './StoreUrlBuilder';
import { AbsoluteUrl } from './Url';

export class DefaultShareConfiguratorUrlProvider extends BaseShareConfiguratorUrlProvider {
  public initialize(shoppingContext: ShoppingContext, storeContext: StoreContext): void {
    // Do nothing;
  }

  public getUrl(code: string, quantity: number = 1): string {
    const query = this.getQuantityQuery(quantity);
    const relativeUrl = StoreUrlBuilder.withContext(
      RouteDefinitions.getUrlTo((x) => x.codeRoute, { code: code }),
      query,
      true,
    );

    return AbsoluteUrl.parse(this.settings.baseUrl).append(relativeUrl).toString();
  }
}
